const partners = [
    {
        
        
        id:1,
        partner_name:"test",
        email:'test@gmail.com',
        partner_phone:1234567890,
    }, {
        
        
        id:2,
        partner_name:"partner2",
        email:'test@gmail.com',
        partner_phone:1234567890,
    },
]


export default partners;